module.exports = __webpack_public_path__ + "media/american-robin-3.93fe6bd7.mp3";